'use strict'

const DAGLink = require('./index.js')

function create (name, size, multihash, callback) {
  const link = new DAGLink(name, size, multihash)
  callback(null, link)
}

module.exports = create



// WEBPACK FOOTER //
// ./node_modules/ipld-dag-pb/src/dag-link/create.js